import { render, staticRenderFns } from "./FrontLayout.vue?vue&type=template&id=511be3b4&scoped=true&"
import script from "./FrontLayout.vue?vue&type=script&lang=js&"
export * from "./FrontLayout.vue?vue&type=script&lang=js&"
import style0 from "./FrontLayout.vue?vue&type=style&index=0&id=511be3b4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "511be3b4",
  null
  
)

export default component.exports